import commitMutation from 'relay-commit-mutation-promise';
import { graphql } from 'react-relay/legacy';

const mutation = graphql`
    mutation dblUserAddAddressMutation($input: UserAddAddressInput!) {
        userAddAddress(input: $input) {
            address {
                serviceId
                firstName
                lastName
            }
        }
    }
`;

export function dblUserAddAddressMutation(environment, args) {
    const { userId, address } = args;

    const input = {
        userId,
        address,
    };

    return commitMutation(environment, {
        mutation,
        variables: { input },
    });
}
